import React, { useState, useEffect } from 'react'
import { Alert, Form, Button, Card, Col, Stack } from 'react-bootstrap'
import { signInWithEmailAndPassword } from 'firebase/auth';

import { useNavigate, useLocation } from "react-router-dom";
import { auth } from '../index';

import { useAuthState } from "react-firebase-hooks/auth";

import { Page } from '../components/Page';

function Login(props) {
  const [user, loading, error] = useAuthState(auth);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const nav = useNavigate();
  const location = useLocation();
  let redirectLocation = location?.state?.next || "/";
  const [validated, setValidated] = useState(false);
  const [wrongEmailOrPW, setWrongEmailOrPW] = useState(false);

  useEffect(() => {
    if (user) {
      console.log("Redirecting to ", redirectLocation, location?.state?.nextState);
      nav(redirectLocation, { state: location?.state?.nextState });
    }
  }, [user, loading]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else {
      signInWithEmailAndPassword(auth, email, password).then((userCred) => {
        console.log("Logged in user ", userCred);
        console.log("Going to", redirectLocation, location?.state?.nextState);
        nav(redirectLocation, { state: location?.state?.nextState });
      }).catch((error) => {
        setWrongEmailOrPW(true);
        console.log(error);
      });
    }
    setValidated(true);
  }

  return (
    <Page>
      <Col md={5} >
        <Card >
          <Card.Body>
            <Card.Title className='text-center'>Login</Card.Title>
            <hr />
            {
              wrongEmailOrPW &&
              <Alert variant="danger" onClose={() => setWrongEmailOrPW(false)} dismissible>
                Wrong Email or Password.
              </Alert>
            }
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control required type="email" placeholder="Enter email"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control required type="password" placeholder="Password"
                  onChange={(e) => setPassword(e.target.value)} />
              </Form.Group>
              <Button className="mb-3" variant="primary" type="submit">
                Login
              </Button>
            </Form>
          </Card.Body>
        </Card>
        <Card className='mt-4'>
          <Card.Body>
            <Stack className='text-center align-items-center'>
              <Card.Text>Don't have an account?</Card.Text>
              <Button variant="outline-primary" type="button" href="signup">
                Create an account
              </Button>
            </Stack>
          </Card.Body>
        </Card>
      </Col>
    </Page>
  );
}

export { Login }
